import { get, post, put, del } from "../../data/api";

// Modes de paiement d'une plateforme (Core.ServicePaymentFlowEnum) : ils fixent les étapes de suivi des locations.
export const SERVICE_PAYMENT_FLOWS = [
    {
        value: "Direct",
        label: "Paiement au loueur",
        description: "Le locataire vous paie directement (espèces, CB, virement, lien de paiement).",
        steps: ["Je confirme avoir reçu le paiement (vaut retrait)"],
        contractTerms: ""
    },
    {
        value: "PlatformCodeAtPickup",
        label: "Plateforme, code au retrait",
        description: "La plateforme encaisse le locataire, qui vous donne un code au retrait pour débloquer le paiement (ex. Bricolib).",
        steps: ["J'ai récupéré le code (vaut retrait et paiement)"],
        contractTerms: "## Article 3bis : Confirmation de la transaction par {{serviceName}}\nAfin de confirmer la transaction, le locataire s'engage à fournir {{lessorDative}} le code {{serviceName}} à la remise du matériel pour déclencher le paiement."
    },
    {
        value: "PlatformCodeAfterRental",
        label: "Plateforme, code en fin de location",
        description: "La plateforme encaisse le locataire, qui vous donne un code au retour du matériel (ex. Kiwiiz).",
        steps: ["Je confirme le retrait", "J'ai récupéré le code (vaut paiement)"],
        contractTerms: "## Article 3bis : Confirmation de la transaction par {{serviceName}}\nAfin de confirmer la transaction, le locataire s'engage à fournir {{lessorDative}} le code {{serviceName}} en fin de prestation pour déclencher le paiement."
    },
    {
        value: "Platform",
        label: "Plateforme, sans code",
        description: "La plateforme encaisse le locataire et vous reverse le paiement sans code (ex. Toolzy).",
        steps: ["Je confirme le retrait (vaut paiement)"],
        contractTerms: "## Article 3bis : Paiement par {{serviceName}}\nLe montant de la location est réglé par le locataire sur {{serviceName}}, qui le reverse {{lessorDative}}. Aucun paiement n'est dû {{lessorDative}} lors de la remise du matériel."
    }
];

export function getServicePaymentFlow(value) {
    return SERVICE_PAYMENT_FLOWS.find((flow) => flow.value === value) || SERVICE_PAYMENT_FLOWS[0];
}

export function formatCommission(value) {
    const number = Number(value || 0);
    return number > 0 ? `${number.toLocaleString("fr-FR", { maximumFractionDigits: 2 })} %` : "aucune";
}

// Le formulaire transmet des chaînes (« 10,5 » ou « 10.5 ») : vide = 0 %.
function toCommissionPercent(value) {
    const number = Number(String(value ?? "").replace(",", "."));
    return Number.isFinite(number) ? number : 0;
}

export async function getServices() {
    return await get('service')
}
export async function getService(id) {
    return await get('service/' + id)
}


export async function createService(params) {
    let serv = {
        Name: params.name,
        Base64Picture: params.picture,
        PaymentFlow: params.paymentFlow,
        CommissionPercent: toCommissionPercent(params.commissionPercent),
        ContractTerms: params.contractTerms ?? ""
    };

    return await post(serv, 'service')
}

export async function updateService(params, id) {
    let serv = {
        Name: params.name,
        Base64Picture: params.picture,
        PaymentFlow: params.paymentFlow,
        CommissionPercent: toCommissionPercent(params.commissionPercent),
        ContractTerms: params.contractTerms ?? ""
    };

    return await put(serv, 'service/' + id)
}

export async function deleteService(id) {
    return await del('service/' + id)
}
